import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_URL = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token and anti-cache headers to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  // Prevent browser caching on GET requests (important for mobile)
  if (config.method === 'get') {
    config.headers['Cache-Control'] = 'no-cache, no-store, must-revalidate';
    config.headers['Pragma'] = 'no-cache';
    config.headers['Expires'] = '0';
    // Add timestamp to bust cache
    config.params = {
      ...config.params,
      _t: Date.now()
    };
  }
  return config;
});

// Handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const currentPath = window.location.pathname;
      // Only clear and redirect if not already on login
      if (currentPath !== '/login') {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        // Use React Router navigation instead of full page reload
        window.history.pushState({}, '', '/login');
        window.dispatchEvent(new PopStateEvent('popstate'));
      }
    }
    return Promise.reject(error);
  }
);

// Auth
export const register = (data) => api.post('/auth/register', data);
export const login = (data) => api.post('/auth/login', data);
export const getMe = () => api.get('/auth/me');
export const getAdminKey = () => api.get('/auth/admin-key');

// Picks
export const getPicks = (params) => api.get('/picks', { params });
export const getPendingPicks = () => api.get('/picks/pending');
export const getPick = (id) => api.get(`/picks/${id}`);
export const createPick = (data) => api.post('/picks', data);
export const updatePick = (id, data) => api.put(`/picks/${id}`, data);
export const deletePick = (id) => api.delete(`/picks/${id}`);
export const markPickSent = (id) => api.post(`/picks/${id}/mark-sent`);
export const getTelegramMessage = (id) => api.get(`/picks/${id}/telegram-message`);

// Combined bets
export const getCombinedBets = (params) => api.get('/combined', { params });
export const createCombinedBet = (data) => api.post('/combined', data);
export const updateCombinedBet = (id, result) => api.put(`/combined/${id}`, { result });
export const markCombinedSent = (id) => api.post(`/combined/${id}/mark-sent`);
export const getCombinedTelegramMessage = (id) => api.get(`/combined/${id}/telegram-message`);

// Stats
export const getStats = () => api.get('/stats');
export const getMonthlyStats = () => api.get('/stats/monthly');

// AI
export const analyzeMatch = (data) => api.post('/ai/analyze', data);

// Config
export const getBookmakers = () => api.get('/config/bookmakers');
export const getLeagues = () => api.get('/config/leagues');

// Events (real sports data)
export const getEvents = (params) => api.get('/events', { params });
export const getAllEvents = (days = 7) => api.get('/events/all', { params: { days } });

export default api;
